import { CookieManagementService } from "src/app/account/services/cookie-management.service";
import { AppConfig } from "src/app/config-service/app.config";

export type Service3dsGateCardOpTypes = "pay-with-credit-card" | "card-save" | "pay-with-defined-card";

export const getBodyCreator = (card_op_type:Service3dsGateCardOpTypes) => {
    if(card_op_type === 'card-save'){
        return new Service3dsGateSaveCardBodyCreator(card_op_type);
    }else if(card_op_type === 'pay-with-credit-card'){
        return new Service3dsGatePayWCCardBodyCreator(card_op_type);
    }else if(card_op_type === 'pay-with-defined-card'){
        return new Service3dsGatePayWDefinedCardBodyCreator(card_op_type);

    }else{
        throw new Error('undefined body creator type!')
    }
}

export abstract class Service3dsGateAbstractBodyCreator<T>{

    constructor(card_op_type:Service3dsGateCardOpTypes){}

    setBody = (params:T) : URLSearchParams => {
        return new URLSearchParams();
    }

}

class Service3dsGateSaveCardBodyCreator<T> extends Service3dsGateAbstractBodyCreator<T>{

    constructor(private card_op_type:Service3dsGateCardOpTypes){
        super(card_op_type)
    }

    setBody = (saveCardOpParams:T |null = null) : URLSearchParams => {
        let body = new URLSearchParams();
    
        Object.entries(saveCardOpParams!).forEach(
          ([key, value]) => {
            body.set(key, value)
          }
        );

        body.set('paymentTypeConf', this.card_op_type);
    
        body.set('islemtipi', 'MerchantSafe');
        body.set('lang', AppConfig.settings.apiServer.lang);
        body.set('MERCHANTSAFE', 'MERCHANTSAFE');
        body.set('MERCHANTSAFEAUTHTYPE', '3DAUTH');
        body.set('refreshtime', '5');
    
        return body;
    }

}

class Service3dsGatePayWDefinedCardBodyCreator<T> extends Service3dsGateAbstractBodyCreator<T>{


    constructor(
        private card_op_type:Service3dsGateCardOpTypes,
    ){
        super(card_op_type);
    }

    setBody = (definedCardOpParams:T | null = null) : URLSearchParams => {
        let body = new URLSearchParams();
           
        Object.entries(definedCardOpParams!).forEach(
          ([key, value]) => {
            body.set(key, value)
          }
        );

        body.set('paymentTypeConf', this.card_op_type);

        body.set('islemtipi', 'Auth');
        body.set('lang', AppConfig.settings.apiServer.lang);
        body.set('region', AppConfig.settings.city.region);
        body.set('bolum', '28');
        body.set('Fismi', 'false');
        body.set('refreshtime', '1');
        body.set('pType', '15');
        body.set('MERCHANTSAFE', 'MERCHANTSAFE');
        //body.set('MERCHANTSAFEAUTHTYPE', '3DAUTH');
        body.set('MERCHANTSAFESELECT', 'MERCHANTSAFESELECT');

        return body;
    }

}

class Service3dsGatePayWCCardBodyCreator<T> extends Service3dsGateAbstractBodyCreator<T>{

    constructor(private card_op_type:Service3dsGateCardOpTypes){
        super(card_op_type)
    }

    setBody = (creditCardOpParams:T) : URLSearchParams => {
        let body = new URLSearchParams();

        Object.entries(creditCardOpParams).forEach(
            ([key, value]) => {
                body.set(key, value)
            }
        );

        body.set('paymentTypeConf', this.card_op_type);

        body.set('islemtipi', 'Auth');
        body.set('lang', AppConfig.settings.apiServer.lang);
        body.set('bolum', '28');
        body.set('region', AppConfig.settings.city.region);
        body.set('Fismi', 'false');
        body.set('refreshtime', '1');
        body.set('pType', '15');

        return body;
    }

}